var $8f6a480bb40b134f$exports = {};
var $8f6a480bb40b134f$var$StatsModule = function() {
    var params = {};
    var reqUrl = "https://px.keepmypixel.com/pixel.aspx";
    function buildQueryString(params) {
        if (!!Object.keys(params).length) {
            var str = "";
            Object.keys(params).map(function(key, i) {
                if (i === 0) str += "?" + key + "=" + params[key];
                else str += "&" + key + "=" + params[key];
            });
            return str;
        }
    }
    function mergeObjects() {
        var resObj = {};
        for(var i = 0; i < arguments.length; i += 1){
            var obj = arguments[i], keys = Object.keys(obj);
            for(var j = 0; j < keys.length; j += 1)resObj[keys[j]] = obj[keys[j]];
        }
        return resObj;
    }
    return {
        getParams: function() {
            return params;
        },
        init: function(initParams) {
            params = mergeObjects(params, initParams);
        },
        sendPixel: function(overrideParams, callback) {
            var pixelParams = mergeObjects(params, overrideParams);
            var queryUrl = reqUrl + buildQueryString(pixelParams);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        if (callback) callback();
                    } else console.error("error");
                }
            };
            xhr.open("GET", queryUrl);
            xhr.send();
        }
    };
}();
let $8f6a480bb40b134f$var$webroot = document.querySelector(":root");
let $8f6a480bb40b134f$var$utilityPortalObj = {};
let $8f6a480bb40b134f$var$hostname = window.location.hostname;
const $8f6a480bb40b134f$var$docstep1id = "zipstep1";
const $8f6a480bb40b134f$var$docstep2id = "zipstep2";
const $8f6a480bb40b134f$var$docstep3id = "zipstep3";
const $8f6a480bb40b134f$var$docstep4id = "zipstep4";
const $8f6a480bb40b134f$var$docstep5id = "pdfstep5";
const $8f6a480bb40b134f$var$docFileInputSelector = "#chooseFile";
const $8f6a480bb40b134f$var$chooseDiffrentFileSelector = "#choose-diffrent-file";
const $8f6a480bb40b134f$var$supportMailId = "support-id";
const $8f6a480bb40b134f$var$termPageId = "termpg";
const $8f6a480bb40b134f$var$privacyPageId = "privacypg";
const $8f6a480bb40b134f$var$downloadBtnSelector = "#downloadBtn";
const $8f6a480bb40b134f$var$convertBtnSelector = "#convertBtn";
const $8f6a480bb40b134f$var$portalNameSelector = "[data-text=portal-name]";
const $8f6a480bb40b134f$var$selectedFileNameSelector = "[data-text=selected-file-name]";
const $8f6a480bb40b134f$var$searchBtnSelector = "#searchBtn";
const $8f6a480bb40b134f$var$searchFormSelector = "#searchForm";
const $8f6a480bb40b134f$var$searchInputSelector = "#query";
const $8f6a480bb40b134f$var$cancelBtnSelector = "#cancelBtn";
var $8f6a480bb40b134f$var$zipContent;
if ($8f6a480bb40b134f$var$hostname == "localhost") $8f6a480bb40b134f$var$hostname = "portal-qa.ziproar.com";
let $8f6a480bb40b134f$var$apiSubDomain = "api";
if ($8f6a480bb40b134f$var$hostname.includes("portal-qa")) $8f6a480bb40b134f$var$apiSubDomain = "api-qa";
$8f6a480bb40b134f$var$utilityPortalObj.Config = {
    getCurrentUrl: function getCurrentUrl() {
        let currentUrl = $8f6a480bb40b134f$var$hostname;
        currentUrl = currentUrl.split(".").length > 2 ? currentUrl.split(".").slice(1, 3).join(".") : currentUrl;
        if (currentUrl === "0.0") return "";
        return currentUrl;
    },
    getApiConvertPdfUrl: function getApiConvertPdfUrl() {
        return ("//" + $8f6a480bb40b134f$var$apiSubDomain + ".").concat($8f6a480bb40b134f$var$utilityPortalObj.Config.getCurrentUrl(), "/converter/post");
    },
    getSearchUrl: function getSearchUrl(q, pid, userid) {
        return $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.SearchUrl + "?q=" + q + "&publisherid=" + pid + "&userid=" + userid;
    },
    getConfigValueUrl: function getConfigValueUrl() {
        return ("//" + $8f6a480bb40b134f$var$apiSubDomain + ".").concat($8f6a480bb40b134f$var$utilityPortalObj.Config.getCurrentUrl(), "/portal/get");
    },
    portalValues: {}
};
$8f6a480bb40b134f$var$utilityPortalObj.Storage = {
    GetItem: function GetItem(name) {
        return localStorage.getItem($8f6a480bb40b134f$var$utilityPortalObj.Config.getCurrentUrl().replace("com", "") + name);
    },
    SetItem: function SetItem(name, value) {
        localStorage.setItem($8f6a480bb40b134f$var$utilityPortalObj.Config.getCurrentUrl().replace("com", "") + name, value);
    },
    RemoveItem: function RemoveItem(name) {
        localStorage.removeItem($8f6a480bb40b134f$var$utilityPortalObj.Config.getCurrentUrl().replace("com", "") + name);
    }
};
$8f6a480bb40b134f$var$utilityPortalObj.ValidationFunc = {
    IsUrlValid: function IsUrlValid(url) {
        return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(url);
    },
    IsFieldValueEmpty: function IsFieldValueEmpty(value) {
        let isempty = false;
        if (value === "") isempty = true;
        return isempty;
    }
};
$(document).ready(function() {
    $8f6a480bb40b134f$var$initPortal(function() {
        let statsData = $8f6a480bb40b134f$var$getStatsData();
        statsData.name = $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.entityName;
        statsData.entity = 26;
        setTimeout(function() {
            $8f6a480bb40b134f$var$StatsModule.init(statsData);
        }, 500);
        $8f6a480bb40b134f$var$initHtml();
        $8f6a480bb40b134f$var$bindEvents();
        $8f6a480bb40b134f$var$getTimer();
    });
});
function $8f6a480bb40b134f$var$initPortal(callback) {
    let currentUrl = $8f6a480bb40b134f$var$hostname;
    currentUrl = currentUrl.split(".").length > 2 ? currentUrl.split(".").slice(1, 3).join(".") : currentUrl;
    $.ajax({
        type: "GET",
        url: $8f6a480bb40b134f$var$utilityPortalObj.Config.getConfigValueUrl(),
        success: function success(response) {
            let data = response.Values;
            $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues = data;
            $8f6a480bb40b134f$var$utilityPortalObj.appConfig = {};
            let staticAssets = "assets/";
            $8f6a480bb40b134f$var$utilityPortalObj.appConfig.currentUrl = currentUrl;
            $8f6a480bb40b134f$var$utilityPortalObj.appConfig.serverMediaUrl = "".concat(data.base_url, "/").concat(data.entityName, "/");
            $8f6a480bb40b134f$var$utilityPortalObj.appConfig.staticImageUrl = "".concat(staticAssets, "img/");
            //set style config
            $8f6a480bb40b134f$var$setCssVariable();
            if (callback) callback();
        },
        error: function error(_error) {
            $("body").css("display", "block");
            $("#not-found-page").css("display", "block");
            console.log(_error);
        }
    });
}
function $8f6a480bb40b134f$var$setCssVariable() {
    $("#zip .blockSec").css("background", $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.ThemeColor);
    $(".defaultBtn").css("background", $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.ButtonColor);
    $(".searchForm .search-btn").css("background", $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.SearchButtonColor || $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.ButtonColor || "#009500");
    if ($8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.ClockColor) $(".clock-widget").css("color", $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.ClockColor);
}
function $8f6a480bb40b134f$var$initHtml() {
    $("head title").html($8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.Name);
    $("head").append("<link rel='icon' type='image/ico' sizes='16x16' href='" + $8f6a480bb40b134f$var$utilityPortalObj.appConfig.serverMediaUrl + "favi.ico'>");
    $("#main-logo").attr("src", $8f6a480bb40b134f$var$utilityPortalObj.appConfig.serverMediaUrl + "logo_txt.png");
    $($8f6a480bb40b134f$var$portalNameSelector).text($8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.Name);
    $(".footer #" + $8f6a480bb40b134f$var$termPageId).attr("href", "//" + $8f6a480bb40b134f$var$utilityPortalObj.appConfig.currentUrl + "/terms.html");
    $(".footer #" + $8f6a480bb40b134f$var$privacyPageId).attr("href", "//" + $8f6a480bb40b134f$var$utilityPortalObj.appConfig.currentUrl + "/privacy.html");
    $(".footer #" + $8f6a480bb40b134f$var$supportMailId).attr("href", "mailto:" + $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.SupportEmail + "?subject=support%20for%20" + $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.Name);
    $(".footer #" + $8f6a480bb40b134f$var$supportMailId).html($8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.SupportEmail);
}
function $8f6a480bb40b134f$var$bindEvents() {
    $8f6a480bb40b134f$var$bindSearchEvents();
    $8f6a480bb40b134f$var$bindDocEvents();
}
function $8f6a480bb40b134f$var$bindSearchEvents() {
    $($8f6a480bb40b134f$var$searchBtnSelector).click($8f6a480bb40b134f$var$submitSearch);
    $($8f6a480bb40b134f$var$searchFormSelector).submit($8f6a480bb40b134f$var$submitSearch);
}
function $8f6a480bb40b134f$var$submitSearch(e) {
    console.log(e);
    e.preventDefault();
    let query = $($8f6a480bb40b134f$var$searchInputSelector).val();
    if (query.length > 0) {
        let pid = $8f6a480bb40b134f$var$StatsModule.getParams().pid;
        let userid = $8f6a480bb40b134f$var$StatsModule.getParams().userid;
        let url = $8f6a480bb40b134f$var$utilityPortalObj.Config.getSearchUrl(query, pid, userid);
        $($8f6a480bb40b134f$var$searchInputSelector).val("");
        console.log(url);
        window.open(url, "_blank");
    }
}
// time section start
function $8f6a480bb40b134f$var$getTimer() {
    setInterval(function() {
        $("#clock-widget").html($8f6a480bb40b134f$var$formatAMPM().toUpperCase());
    }, 1000);
}
function $8f6a480bb40b134f$var$formatAMPM() {
    console.log("formatAMPM");
    let date = new Date();
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
}
// time section end
// pdf section start
function $8f6a480bb40b134f$var$bindDocEvents() {
    var zip = new JSZip();
    var zipSize = 0;
    var maxSize = 20971520;
    $($8f6a480bb40b134f$var$docFileInputSelector).change(async function() {
        if (Object.keys(zip.files).length != 0) CleanZip();
        for(var i = 0; i < this.files.length; i++){
            var file = this.files[i];
            if (file.size > maxSize) continue;
            zipSize += file.size;
            zip.file(file.name, file);
        }
        if (Object.keys(zip.files).length != 0) $8f6a480bb40b134f$var$showDocStep(2);
    });
    $("#converBtn").click(async function() {
        if (Object.keys(zip.files).length === 0) {
            zipSize = 0;
            return;
        }
        if (zipSize > maxSize) {
            CleanZip();
            zipSize = 0;
            $8f6a480bb40b134f$var$showDocStep(1);
            return;
        }
        $8f6a480bb40b134f$var$showDocStep(3);
        zip.generateAsync({
            type: "blob"
        }).then(function(content) {
            $8f6a480bb40b134f$var$showDocStep(4);
            $8f6a480bb40b134f$var$zipContent = content;
        });
    });
    $("#downloadBtn").click(async function() {
        saveAs($8f6a480bb40b134f$var$zipContent, "MyZippedFiles.zip");
    });
    $($8f6a480bb40b134f$var$cancelBtnSelector).click(function() {
        if (Object.keys(zip.files).length != 0) CleanZip();
        $8f6a480bb40b134f$var$zipContent = null;
        $($8f6a480bb40b134f$var$docFileInputSelector).val(null);
        $8f6a480bb40b134f$var$showDocStep(1);
    });
    function CleanZip() {
        var numberOfFiles = Object.keys(zip.files).length;
        for(var i = 0; i < numberOfFiles; i++){
            var fileName = zip.files[Object.keys(zip.files)[0]].name;
            zip.remove(fileName);
        }
    }
}
function $8f6a480bb40b134f$var$showDocStep(stepnumber) {
    $("#" + $8f6a480bb40b134f$var$docstep1id).hide();
    $("#" + $8f6a480bb40b134f$var$docstep2id).hide();
    $("#" + $8f6a480bb40b134f$var$docstep3id).hide();
    $("#" + $8f6a480bb40b134f$var$docstep4id).hide();
    $("#" + $8f6a480bb40b134f$var$docstep5id).hide();
    if (stepnumber == 1) $("#" + $8f6a480bb40b134f$var$docstep1id).show();
    else if (stepnumber == 2) $("#" + $8f6a480bb40b134f$var$docstep2id).show();
    else if (stepnumber == 3) $("#" + $8f6a480bb40b134f$var$docstep3id).show();
    else if (stepnumber == 4) $("#" + $8f6a480bb40b134f$var$docstep4id).show();
    else if (stepnumber == 4) $("#" + $8f6a480bb40b134f$var$docstep5id).show();
}
// pdf section end
// common utility function start
function $8f6a480bb40b134f$var$getStatsData() {
    let barcode = $8f6a480bb40b134f$var$getCookie("barcode", $8f6a480bb40b134f$var$getParameterByName("barcodeid", $8f6a480bb40b134f$var$utilityPortalObj.Config.portalValues.defaultPid || "234004"));
    let pid = barcode.substring(0, 5); // parse the pid only
    let uid = $8f6a480bb40b134f$var$getCookie("uid", $8f6a480bb40b134f$var$getParameterByName("userid", $8f6a480bb40b134f$var$uuid()));
    let co = $8f6a480bb40b134f$var$getCookie("co", $8f6a480bb40b134f$var$getParameterByName("co", "tj"));
    let installDate = $8f6a480bb40b134f$var$getCookie("installDate", $8f6a480bb40b134f$var$getParameterByName("installdate", "01-01-1970"));
    return {
        installDate: installDate,
        co: co,
        barcode: barcode,
        userid: uid,
        pid: pid
    };
}
function $8f6a480bb40b134f$var$uuid() {
    function randomDigit() {
        if (crypto && crypto.getRandomValues) {
            let rands = new Uint8Array(1);
            crypto.getRandomValues(rands);
            return (rands[0] % 16).toString(16);
        } else return (Math.random() * 16 | 0).toString(16);
    }
    let crypto = window.crypto || window.msCrypto;
    return "xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx".replace(/x/g, randomDigit);
}
function $8f6a480bb40b134f$var$getCookie(name, def) {
    let v = document.cookie.match("(^|;) ?" + name + "=([^;]*)(;|$)");
    return v ? v[2] : def;
}
function $8f6a480bb40b134f$var$getBooleanFromConfig(value, defaultVal) {
    return typeof value !== "undefined" ? value === "true" : defaultVal;
}
function $8f6a480bb40b134f$var$getParameterByName(name, def) {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results) return def;
    if (!results[2]) return def;
    return decodeURIComponent(results[2].replace(/\+/g, " "));
} // common utility function end


//# sourceMappingURL=index.8fbf343a.js.map
